module.exports = __webpack_public_path__ + "static/media/OnDemandPrintListItem_elImage_29977.5f900eee.jpg";